// src/components/OtpSixInput.jsx
import React, { useRef, useEffect } from "react";

export default function OtpSixInput({ value = "", onChange, disabled }) {
  const inputsRef = useRef([]);

  const digits = (value || "").toString().slice(0, 6).padEnd(6, " ").split("");

  const handleChange = (index, e) => {
    const v = e.target.value.replace(/\D/g, "").slice(0, 1); // numbers only, 1 char
    const arr = digits.slice();
    arr[index] = v || " ";
    const joined = arr.join("").replace(/\s/g, "");
    onChange?.(joined);

    if (v && index < 5) {
      inputsRef.current[index + 1]?.focus();
      inputsRef.current[index + 1]?.select?.();
    }
  };

  const handleKeyDown = (index, e) => {
    const key = e.key;

    if (key === "Backspace") {
      if (digits[index] === " " || !digits[index]) {
        // move back & clear previous
        if (index > 0) {
          const prev = inputsRef.current[index - 1];
          onChange?.((value || "").slice(0, index - 1) + (value || "").slice(index));
          prev?.focus();
          prev?.select?.();
        }
      } else {
        // clear current
        const arr = digits.slice();
        arr[index] = " ";
        onChange?.(arr.join("").replace(/\s/g, ""));
      }
    }

    if (key === "ArrowLeft" && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
    if (key === "ArrowRight" && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  useEffect(() => {
    // focus first empty box if nothing entered
    if (!value) inputsRef.current[0]?.focus();
  }, [value]);

  return (
    <div className="d-flex gap-2 justify-content-center">
      {Array.from({ length: 6 }).map((_, i) => (
        <input
          key={i}
          type="text"
          inputMode="numeric"
          pattern="\d*"
          className="form-control text-center"
          style={{ width: 48, height: 48, fontSize: 20 }}
          maxLength={1}
          value={digits[i] === " " ? "" : digits[i]}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          ref={(el) => (inputsRef.current[i] = el)}
          disabled={disabled}
          aria-label={`OTP digit ${i + 1}`}
        />
      ))}
    </div>
  );
}
